import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ErrorFormatter } from '../../../shared/formatter/error.formatter';
import { LeadService } from '../../../shared/services/lead/lead.service';
import { AuthService } from '../../../shared/services/security/auth.service';
import { TrackAnalyticsService } from '../../../shared/services/track-analytics/track-analytics.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { TranslatorService } from '../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { EmailSenderComponent } from '../../shared-component/forms/email-sender/email-sender.component';
import { ModalsHandlerService } from '../modals.handler.service';
import { EmailContact } from './../../../shared/models/lead/emailContact';
import { UserService } from './../../../shared/services/user/user.service';

@Component({
  selector: 'ngx-send-email',
  templateUrl: './send-email.component.html',
  styleUrls: []
})
export class SendEmailComponent extends EmailSenderComponent implements AfterViewInit, OnDestroy {

  @ViewChild('content', { static: false }) content: ElementRef;
  hasMessageId: boolean;
  respond = false;
  receiver = true;
  createDate: number;
  emailContact: EmailContact;
  modalHandlerSubcription: Subscription;
  constructor(
    private readonly modalsHandler: ModalsHandlerService,
    private readonly modalService: NgbModal,
    protected readonly userLogged: AuthService,
    protected readonly leadService: LeadService,
    protected readonly toasterService: ToastService,
    protected readonly leadComuService: LeadsComunicationService,
    protected readonly formBuilder: FormBuilder,
    protected readonly spinner: NgxSpinnerService,
    protected readonly translateService: TranslatorService,
    protected readonly errorFormatter: ErrorFormatter,
    protected readonly trackAnalytics: TrackAnalyticsService,
    protected readonly userService: UserService,
  ) {
    super(formBuilder, translateService, userLogged, userService, spinner, leadService, trackAnalytics,
      leadComuService, toasterService, errorFormatter);
  }

  ngAfterViewInit(): void {
    this.resetForm();

    this.modalHandlerSubcription = this.modalsHandler.sendMailModal.subscribe(data => {
      this.subject = data.emailSubject;
      this.emailMessage = data.contactName;
      this.hasMessageId = data.hasMessage;
      this.getSignMail();
      this.createDate = data.createdAt;
      this.respond = data.hasMessage;
      if (this.hasMessageId) {
        this.subject = 'RE: ' + this.subject;
      } else {
        this.subject = 'RE:';
      }

      this.leadId = data.leadId;
      this.contactName = data.contactName;
      this.modalService
        .open(this.content, {
          size: 'lg',
          container: 'nb-layout',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static', keyboard: false
        });
    });
  }

  ngOnDestroy() {
    this.modalHandlerSubcription.unsubscribe();
  }

  respondWithNotification() {
    this.respond = !this.respond;
    if (!this.respond) {
      this.f.subject.setValue(this.f.subject.value.replace(this.translateService.trans('modal.subject.response'), ''));
    } else {
      this.f.subject.setValue(this.translateService.trans('modal.subject.response') + this.f.subject.value);
    }

  }

  addReceiver() {
    this.receiver = !this.receiver;
  }

  checkLeadCreatedByInbound() {
    if (!this.respond) {
      this.subject = '' + this.subject;
    }
  }
  handlerEmailSended() {
    this.modalService.dismissAll();
  }

  send() {
    this.leadService.sendEmailContact$(this.emailContactInput).subscribe(this.emailSendedHandler, this.emailErrorHandler);
  }

}
